<template>
  <div class="card-history-container">
    <div class="header">
      <h3 class="title">История</h3>
      <toggle-button
        class="switch"
        :value="true"
        @change="onChangeEventHandler"
        :labels="{
          unchecked: 'все',
          checked: 'доска'
        }"
        :width="65"
      />
    </div>

    <virtual-list class="history-event-container" :size="40" :remain="8">
      <div class="history-event" v-for="event in sortedEvents" :key="event.id">
        <span class="event-user">{{ toHumanUserName(event.user_id) }}</span>
        <span v-html="formatEventBeforeCard(event)" />
        <a class="card-link" v-if="event.card_id > 0" href="#" @click.prevent="editCard(event.card_id)">{{ event.in_board_id }}</a>
        <span v-html="formatEventAfterCard(event)" />
        <span class="timestamp">{{ toHumanTime(event.moment) }}</span>
      </div>
    </virtual-list>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { sortByDateDescending } from "@/common/utils.sort";
import { EDIT_CARD, SWITCH_SHOW_HISTORY } from "@/store/actions.type";
import ToggleButton from "./general/ToggleButton.vue";

import virtualList from "vue-virtual-scroll-list";

import cache from "@/store/cache.js";
import eventAction from "../store/eventAction";

export default {
  name: "History",
  computed: {
    ...mapGetters(["isMobileDevice"]),
    ...mapState("events", ["all"]),
    ...mapState("boards", { activeBoard: "active" }),
    sortedEvents() {
      if (this.onlyForActiveBoard && this.activeBoard) {
        return sortByDateDescending(this.all.filter((e) => e.board_id == this.activeBoard.id));
      }
      return sortByDateDescending(this.all);
    }
  },
  components: { ToggleButton, virtualList },
  data() {
    return {
      onlyForActiveBoard: true
    };
  },
  methods: {
    onChangeEventHandler({ value }) {
      this.onlyForActiveBoard = value;
    },
    hide() {
      this.$store.commit(SWITCH_SHOW_HISTORY);
    },
    editCard(card_id) {
      this.$store.dispatch(EDIT_CARD, card_id);
    },
    toHumanUserName(user_id) {
      if (!user_id) return user_id;

      const user = cache.users.byId(user_id);
      if (user) {
        return user.name;
      }

      return user_id;
    },
    formatEventBeforeCard(event) {
      const actionInfo = eventAction.getInfo(event.action);
      const card = cache.cards.byId(event.card_id);
      if (card) {
        event.in_board_id = card.in_board_id;
      }
      let msg = "";
      if (actionInfo) {
        msg += " " + actionInfo.description;
      }
      if (event.data && actionInfo && actionInfo.hasTextData) {
        msg += ' <pre class="history-inline-pre">"' + event.data + '"</pre>';
      }
      if (card) {
        msg += " карточку ";
      }

      return msg;
    },
    formatEventAfterCard(event) {
      const board = cache.boards.byId(event.board_id);
      const list = cache.lists.byId(event.list_id);

      let msg = "";
      if (list) {
        msg += " в списке <b>" + list.title + "</b>";
      }
      if (board) {
        msg += " на доске <b>" + board.title + "</b>";
      }
      return msg;
    },
    toHumanTime(time) {
      if (!time) return time;

      return time.format("DD.MM.YY HH:mm:ss");
    }
  }
};
</script>

<style lang="postcss">
.card-history-container {
  display: grid;
  grid-template-areas:
    "header"
    "events";
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  max-height: var(--history-max-height);

  width: 350px;
  max-width: 350px;
  vertical-align: top;
  padding: 8px 7px 8px 8px; /* 7px cause .history-event-container has padding-right 1px */
  border-radius: 8px;
  background: var(--bg-list);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
  color: var(--color-list);
  height: 100%;
  .header {
    position: relative;
    .title {
      margin: 0 0 10px;
      font-size: 14px;
      text-transform: uppercase;
      color: #999;
      padding: 5px;
      border-bottom: 1px dashed #ddd;
      text-overflow: ellipsis;
      user-select: none;
    }
    .switch {
      position: absolute;
      right: 0;
      top: 0;
      display: inline-block;
    }
  }
  .history-event-container {
    height: 100% !important;
    overflow-y: auto;
    padding-right: 1px;

    .history-event {
      position: relative;
      border-radius: 5px;
      background: var(--bg-card);
      color: var(--color-card);
      border: 1px solid var(--border-card);
      margin-bottom: 5px;
      padding: 0px 10px;
      overflow-x: auto;

      .event-user {
        font-weight: bold;
      }

      .timestamp {
        display: block;
        font-size: 10px;
        color: #888;
        font-weight: bold;
        line-height: 16px;
        text-align: right;
      }
    }
  }
}
</style>
